module.exports = ".centered{margin:0 auto;}\r\n"